import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const datasourceColumnsManager = {
  getDatasourceColumns(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default datasourceColumnsManager;
